import styled from 'styled-components';

import { useConfig } from '@wecasa/common/src/providers/config-provider';
import type { ChildcareBasketPrices } from '@wecasa/common/src/types/commons';
import { formatPricePerHour } from '@wecasa/common/src/utils/formatting';

import { getBasketPrices } from '@wecasa/customer/src/ducks/basket-selectors';

import { translate } from '@wecasa/i18n';

import Text from '@wecasa/web-ui/src/components/base-text/variants/text';

import { useAppSelector } from '../../../store';

const t = translate('prices');

const PriceWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
`;

const ChildcarePreview = () => {
  const config = useConfig();
  const prices = useAppSelector((state) => getBasketPrices(state, config)) as ChildcareBasketPrices;

  return (
    <PriceWrapper>
      <Text.MDBold>{formatPricePerHour(prices.totalHourlyPriceAfterTax)}</Text.MDBold>
      {!!prices.totalHourlyPrice && (
        <div>
          <Text.MDBold>{`${formatPricePerHour(prices.totalHourlyPrice)} `}</Text.MDBold>
          <Text.XS>{t('.before_tax')}</Text.XS>
        </div>
      )}
    </PriceWrapper>
  );
};

export default ChildcarePreview;
